import { render, staticRenderFns } from "./UniversalBankPaymentTransactionEditModal.vue?vue&type=template&id=766931c9&scoped=true&"
import script from "./UniversalBankPaymentTransactionEditModal.vue?vue&type=script&lang=js&"
export * from "./UniversalBankPaymentTransactionEditModal.vue?vue&type=script&lang=js&"
import style0 from "./UniversalBankPaymentTransactionEditModal.vue?vue&type=style&index=0&id=766931c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766931c9",
  null
  
)

export default component.exports